import ReactGA from 'react-ga';
import { config } from './config';
import { isDevelopment } from 'web-shared/lib';

const enabled = !isDevelopment && !!config.googleAnalyticsCode;

if(enabled) {
    if(config.client.id === 1032 && config.site.id === 'consumer') {
        ReactGA.initialize(config.googleAnalyticsCode, { gaOptions: { cookieDomain: 'auto', allowLinker: true }, });
        ReactGA.plugin.require('linker');
        ReactGA.plugin.execute('linker', 'autoLink', ['ucbi.com']);
    } else {
        ReactGA.initialize(config.googleAnalyticsCode);
    }
}

export function gaPageView(pathName: string) {
    enabled && ReactGA.pageview(pathName);
}
export function gaEvent(category: string, action: string) {
    enabled && ReactGA.event({ category, action });
}
